module.exports = __webpack_public_path__ + "img/alert-icon.93914a6d.svg";